import script from "./mypurchase.vue?vue&type=script&setup=true&lang=js"
export * from "./mypurchase.vue?vue&type=script&setup=true&lang=js"

import "./mypurchase.vue?vue&type=style&index=0&id=a691ce2a&scoped=true&lang=css"

import exportComponent from "F:\\proj-abhinav\\meraki\\patient-portal-v3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a691ce2a"]])

export default __exports__